import { render, staticRenderFns } from "./TalleresHomeComponent.vue?vue&type=template&id=086eb1fe&"
import script from "./TalleresHomeComponent.vue?vue&type=script&lang=js&"
export * from "./TalleresHomeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports